import React from 'react';
import type { RequireAuthProps } from "@/types";
import {RootState} from "./store";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { Console } from 'console';


const RequireAuth = (props: RequireAuthProps) => {
    const {allowedRoles} = props;
    const token = useSelector((state: RootState) => state.authentications.user.token);
    // const token = "hello"
    const userRole = useSelector((state: RootState) => state.authentications.user.userRole);
    // const userRole = 'user';
    const status = useSelector((state: RootState) => state.authentications.status);
    const tokenValid = useSelector((state: RootState) => state.authentications.tokenValid);
    const location = useLocation();
    let roles = [userRole]


    return (
        roles.find(role => allowedRoles?.includes(role))
            ? tokenValid
                ?<Outlet />
                :<Navigate to="/login" state={{ from: location }} replace />
            : token
                ? <Navigate to="/login" state={{ from: location }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}





  export default RequireAuth;
